import { useScriptHotjar, useScript, defineNuxtPlugin } from '#imports'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const hotjar = useScriptHotjar({"id":5060044})
    return { provide: { $scripts: { hotjar } } }
  }
})